export default __webpack_public_path__ + "static/media/JoeMontana.431b55de.JPG";